import { useFlags } from 'launchdarkly-react-client-sdk';
import React from 'react';

import { navigationService } from 'src/config/rootService';

import { Scores, SetOfAssessments } from '../components/SetOfAssessments';
import { FlowType } from '../models/assessments';

export const RetakeAssessmentsPage: React.FC<{ isFullAssessment?: boolean }> = ({
    isFullAssessment = false,
}) => {
    const flags = useFlags();
    const handleAssessmentSubmit = (scores: Scores) => {
        navigationService.navigate('/wellbeing-check-score', { score: scores.who5 });
    };

    const showFullAssessment = flags?.showFullAssessmentMember && isFullAssessment;

    return (
        <SetOfAssessments
            onSubmit={handleAssessmentSubmit}
            flowType={FlowType.MEMBER_WEB_SETTINGS}
            showFullAssessment={showFullAssessment}
        />
    );
};
